var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRealmSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2L3 9.5v13L16 30l13-7.5v-13L16 2zm0 4.3L25.3 11 16 16.3 6.7 11 16 6.3zM6.5 13.5L14.5 18v8.3l-8-4.6v-7.2zm19 0v7.2l-8 4.6V18l8-4.5z",
    fill: "#9C27B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealmSvgrepoCom);
export default __webpack_public_path__ + "static/media/realm-svgrepo-com.8a5355920537881bb705366c97925283.svg";
export { ForwardRef as ReactComponent };